interface CaptureModalProps {
  deviceName: string;
  deviceId: string;
  onCancel: () => void;
  onConfirm: () => void;
  message?: string;
}

export default function CaptureModal({
  deviceName,
  deviceId,
  onCancel,
  onConfirm,
  message,
}: CaptureModalProps) {
  const bodyText = message || (
    <>
      <strong className="text-gray-800">{deviceName}</strong> 장비에서 즉시 촬영을 실행합니다.
    </>
  );

  const detailText = message ? null : (
    <p className="text-sm text-gray-500 leading-relaxed mt-2">
      RGB1, RGB2, NIR, ToF 촬영 후 서버로 전송되며 약 <strong className="text-gray-700">40~60초</strong>가 소요됩니다.
    </p>
  );

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onCancel}></div>
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-hidden">
        {/* Header */}
        <div className="px-6 pt-6 pb-4">
          <div className="flex items-center gap-3 mb-1">
            <div
              className="w-10 h-10 flex items-center justify-center rounded-xl"
              style={{ backgroundColor: '#27ae6018' }}
            >
              <i className="ri-camera-line text-xl" style={{ color: '#27ae60' }}></i>
            </div>
            <h2 className="text-lg font-bold text-gray-800">수동 촬영</h2>
          </div>
        </div>

        {/* Body */}
        <div className="px-6 pb-2">
          <p className="text-sm text-gray-600 leading-relaxed">
            {bodyText}
          </p>
          {detailText}

          <div className="mt-4 bg-gray-50 rounded-xl p-3 flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center shrink-0">
              <i className="ri-cpu-line text-gray-400 text-sm"></i>
            </div>
            <span className="text-xs text-gray-500 font-mono">{deviceId}</span>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 flex items-center justify-end gap-2 border-t border-gray-100 mt-2">
          <button
            onClick={onCancel}
            className="px-5 py-2 rounded-lg text-sm font-medium text-gray-600 hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            취소
          </button>
          <button
            onClick={onConfirm}
            className="px-5 py-2 rounded-lg text-sm font-semibold text-white cursor-pointer whitespace-nowrap transition-all hover:brightness-110"
            style={{ backgroundColor: '#27ae60' }}
          >
            촬영 실행
          </button>
        </div>
      </div>
    </div>
  );
}